<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M11.125 20.34H13V14.31L15.5625 16.77L16.875 15.51L12 10.95L7.1875 15.57L8.5 16.83L11.125 14.31V20.34ZM3.875 24C3.375 24 2.9375 23.82 2.5625 23.46C2.1875 23.1 2 22.68 2 22.2V1.8C2 1.32 2.1875 0.9 2.5625 0.54C2.9375 0.18 3.375 0 3.875 0H15.1562L22 6.57V22.2C22 22.68 21.8125 23.1 21.4375 23.46C21.0625 23.82 20.625 24 20.125 24H3.875ZM14.2188 7.38V1.8H3.875V22.2H20.125V7.38H14.2188Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
